export default __webpack_public_path__ + "static/media/credit-card.f7b49a9b.svg";